import React, { useState, ChangeEvent } from 'react';

import { observer } from 'mobx-react-lite';

import Title from '@vromo/ui/components/Title';
import { ModalHeader, ModalContent, ModalActions } from '@vromo/ui/components/Modal';
import Input from '@vromo/ui/components/Input';
import Button from '@vromo/ui/components/Button';
import { useToasts } from '@vromo/ui/components/Toasts';
import { qaLabelTeams } from './../../../../../common-qa-labels/teams';

interface Props {
    name: string;
    save: (name: string) => void;
    close: () => void;
}

export default observer<Props>(function EditSelectedTeamForm({ name, save, close }) {
    const [groupName, setGroupName] = useState(name);
    const showToast = useToasts();
    
    const isValidGroup = () => {
        const allFieldsFilled = !!groupName.trim();
        const showError = (validated: boolean, message: string) => {
            if (validated) {
                return true;
            } else {
                showToast(message);
                return false;
            }
        };

        return (
            showError(allFieldsFilled, 'Please fill out all fields before adding a new team.')
        );
    };


    const handleSave = () => {
        if (!isValidGroup()) {
            return;
        }
        else
            save(groupName.trim());
    }

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => setGroupName(e.target.value);

    return (
        <>
            <ModalHeader>
                <Title data-testid={qaLabelTeams.editTeamModal.title}>Edit Team</Title>
            </ModalHeader>
            <ModalContent>
                <Input
                    data-testid={qaLabelTeams.editTeamModal.newNameInput}
                    label="New Name"
                    style={{ marginBottom: 10 }}
                    value={groupName}
                    onChange={handleChange}
                />
            </ModalContent>
            <ModalActions>
                <Button onClick={close}>Cancel</Button>
                <Button data-testid={qaLabelTeams.editTeamModal.saveEditedTeam} onClick={handleSave} primary>
                    Save
                </Button>
            </ModalActions>
        </>
    );
});


